export const HOSTNAME = window.location.hostname.includes('localhost') ? 'dev.hub.inspire.direct' : window.location.hostname
